import { createApp } from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import ConfirmationService from 'primevue/confirmationservice';

import '@fortawesome/fontawesome-free/css/all.css'
import '@fortawesome/fontawesome-free/js/all.js'

import PrimeVue from 'primevue/config';
import VueAxios from "vue-axios";
import axios from "axios";
import {dateLocales} from "./api";
import Tooltip from "primevue/tooltip";
import ToastService from "primevue/toastservice";
import DialogService from 'primevue/dialogservice';
import Material from '@primeuix/themes/material';
import {definePreset} from "@primeuix/themes";
import {axiosInstance} from "../../core/api/instance";

axiosInstance.defaults.headers.common['X-App-Source'] = 'admin-panel';

const preset = definePreset(Material, {
    semantic: {
        primary: {
            50: '{indigo.50}',
            100: '{indigo.100}',
            200: '{indigo.200}',
            300: '{indigo.300}',
            400: '{indigo.400}',
            500: '#3f51b5',
            600: '#3f51b5',
            700: '{indigo.700}',
            800: '{indigo.800}',
            900: '{indigo.900}',
            950: '{indigo.950}'
        }
    }
});

createApp(App)
    .use(router)
    .use(VueAxios, axios)
    .use(PrimeVue, {
        theme: {
            preset: preset,
            options: {
                darkModeSelector: 'none'
            }
        },
        ripple: true,
        locale: {
            accept: 'Tak',
            reject: 'Nie',
            ...dateLocales
        }
    })
    .use(ToastService)
    .use(DialogService)
    .use(ConfirmationService)
    .directive('tooltip', Tooltip)
    .mount('#app');
